// extracted by mini-css-extract-plugin
export default {"container":"style_container__-Bdan","content":"style_content__tbmrS","title":"style_title__rKc23","title_header":"style_title_header__k41kg","title_inner":"style_title_inner__DRTM3"};